export const PROTOCOL_OPTIONS = { 'socks5': 'SOCKS5', 'http': 'HTTP' };

// Регион выхода (exit_region) — континент страны выхода, как его считает бэкенд.
export const REGION_OPTIONS = {
    'EU': 'EU — Европа',
    'US': 'US — Северная Америка',
    'AS': 'AS — Азия',
    'SA': 'SA — Южная Америка',
    'AF': 'AF — Африка',
    'OC': 'OC — Океания',
};

// «хост:порт». IPv6 хранится без скобок — в выводе берём в скобки, иначе в «2001:db8::1:1080»
// не видно, где кончается адрес и начинается порт.
export function formatProxyAddress(host, port) {
    const address = String(host ?? '').includes(':') ? `[${host}]` : host;
    return `${address}:${port}`;
}

// Выход прокси: «91.247.163.39 · EU\DE» — измеренный IP, регион и страна выхода. Неизвестная часть —
// «—» на её месте (как в подписи app-init, AppInitController::ExitLabel); IP нет — «—» целиком.
export function formatProxyExit(proxy) {
    if (!proxy?.exit_ip) return '—';
    const region = proxy.exit_region ?? null;
    const countryCode = proxy.exit_country_code ?? null;
    if ((region === null) && (countryCode === null)) return proxy.exit_ip;
    return `${proxy.exit_ip} · ${region ?? '—'}\\${countryCode ?? '—'}`;
}

// Режим самого прокси (proxies.mode) — что он умеет нести: tcp_udp — TCP и UDP, tcp — только TCP,
// null — ещё не определён (его определит первая проверка). Подписи — справочник app-init
// device_proxy_modes (те же значения, что у режима устройства).
export const PROXY_MODE_UNKNOWN_LABEL = 'не определён';

export function proxyModeLabel(mode, deviceProxyModes) {
    if (!mode) return PROXY_MODE_UNKNOWN_LABEL;
    return deviceProxyModes[mode] ?? mode;
}
